module.exports = __webpack_public_path__ + "img/x-circle.b6ac6b57.svg";